import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router, RouterLink } from '@angular/router'
import { CaseListComponent } from '../../../abacus/components/case-list.component'
import { HasPermissionDirective } from '../../../abacus/directives/has-permission.directive'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { MetaComponent } from '../../../abacus/elements/partials/meta/meta.component'
import { PaginationComponent } from '../../../abacus/elements/partials/pagination/pagination.component'
import { TableComponent } from '../../../abacus/elements/partials/table/table.component'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { Filter } from '../../../abacus/interfaces/filter.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { EurosPipe } from '../../../abacus/pipes/euros.pipe'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FilterService } from '../../../abacus/services/filter.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseListTemplate } from '../../../abacus/templates/case-list.template'
import { PolicyInitiativeEditorialStatus } from '../../../common/enums/policy-initiative-editorial-status.enum'
import { countryDefinition } from '../../country/country.definition'
import { initiativeTypeDefinition } from '../../initiative-type/initiative-type.definition'
import { intergovernmentalOrganisationDefinition } from '../../intergovernmental-organisation/intergovernmental-organisation.definition'
import { policyInitiativeDefinition } from '../policy-initiative.definition'
import { policyInitiativeYields } from '../policy-initiative.yields'

@Component({
    template: caseListTemplate,
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        HasPermissionDirective,
        CaseInputComponent,
        MetaComponent,
        TableComponent,
        PaginationComponent,
        EurosPipe
    ]
})
export class PolicyInitiativeListComponent
  extends CaseListComponent
  implements OnInit
{
  definition: ResourceDefinition = policyInitiativeDefinition

  yields = policyInitiativeYields

  filters: Filter[] = [
    {
      label: 'Country',
      properties: {
        countryIds: 'countryIds'
      },
      inputType: InputType.MultiSearch,
      searchResources: [countryDefinition],
      className: 'is-6'
    },
    {
      label: 'International organisation or forum',
      properties: {
        intergovernmentalOrganisationIds: 'intergovernmentalOrganisationIds'
      },
      inputType: InputType.MultiSearch,
      searchResources: [intergovernmentalOrganisationDefinition],
      className: 'is-6'
    },
    {
      label: 'Search a policy initiative',
      properties: {
        policyInitiativeIds: 'policyInitiativeIds'
      },
      inputType: InputType.MultiSearch,
      searchResources: [policyInitiativeDefinition],
      className: 'is-6'
    },
    {
      label: 'Policy initiative type',
      properties: {
        initiativeTypeIds: 'initiativeTypeIds'
      },
      inputType: InputType.MultiSearch,
      searchResources: [initiativeTypeDefinition],
      className: 'is-6'
    },
    {
      label: 'Publication status',
      property: 'editorialStatus',
      inputType: InputType.Select,
      selectOptions: [
        {
          label: 'All statuses',
          value: null
        },
        {
          label: 'Published',
          value: PolicyInitiativeEditorialStatus.Published
        },
        { label: 'Draft', value: PolicyInitiativeEditorialStatus.Draft },
        { label: 'Rejected', value: PolicyInitiativeEditorialStatus.Rejected },
        { label: 'Pending', value: PolicyInitiativeEditorialStatus.Pending }
      ],
      className: 'is-6'
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    authService: AuthService,
    filterService: FilterService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
